export const PILOT_EQUIP_LOG_LIST_REQUEST = "PILOT_EQUIP_LOG_LIST_REQUEST";

export const PILOT_SKILL_CHANGE_LOG_LIST_REQUEST = "PILOT_SKILL_CHANGE_LOG_LIST_REQUEST";

export const PILOT_DISASSEMBLE_LOG_LIST_REQUEST = "PILOT_DISASSEMBLE_LOG_LIST_REQUEST";

export const PILOT_PROMOTION_LOG_LIST_REQUEST = "PILOT_PROMOTION_LOG_LIST_REQUEST";

// 1.PilotEquipLogList
// 2.PilotSkillChangeLogList
// 3.PilotDisassembleLogList
// 4.PilotPromotionLogList